// import config from '@config';
export default class AjaxFormat {
  constructor() {
    this.formatRules = new Map();
  }
  add(url, format) {
    this.formatRules.set(url, format);
  }
  // res 可以是返回对象， 也可以是axios请求对象
  format(res) {
    const url = res?.config?.url || res.url;
    if (this.formatRules.has(url)) {
      // if (config.debug) {
      //   console.info('ajax format:', url);
      // }
      return this.formatRules.get(url)(res);
    }
    return res;
  }
}
